module.exports = __webpack_public_path__ + "img/illustration-woman.f01cb55a.png";